import {easasAxios} from "../../../services/HttpService";
import {ScadaProps} from "./scadaTypes";
import {getEasasRestUrl} from "../../../utils/utils";


export function getScadaImageUrl(scadaProps: ScadaProps) {
    return getEasasRestUrl() + "/images/" + scadaProps.scadaBackgroundId;
}

export function getScadaData(identifiers: Array<string>, refTime?: string) {
    return easasAxios.post("/datasetData/dataInfoRecent", identifiers, {params: {refTime: refTime}})
        .then(res => res.data)
}